import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Popup, Segment } from "semantic-ui-react";

export const MonthYearPicker = ({ onChange, locale = "en-GB" }) => {
  const [months, setMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [outputDate, setOutputDate] = useState(new Date());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setMonths(
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((monthIndex) =>
        new Date(2000, monthIndex, 1).toLocaleString(locale, { month: "short" })
      )
    );
  }, [locale]);

  useEffect(() => {
    if (outputDate) onChange(outputDate);
  }, [outputDate]);

  useEffect(() => {
    setOutputDate(new Date(selectedYear, selectedMonth, 2));
  }, [selectedMonth, selectedYear]);

  const decreaseYear = () => {
    setSelectedYear(selectedYear - 1);
  };

  const incrementYear = () => {
    setSelectedYear(selectedYear + 1);
  };

  return (
    <div id="YearMonthPicker">
      <Popup
        position="bottom center"
        basic
        trigger={
          <div className="ui icon input">
            <input
              type="text"
              value={outputDate.toLocaleString(locale, { year: "numeric", month: "short" })}
              onClick={() => setOpen(true)}
            />
            <i data-testid="datepicker-icon" aria-hidden="true" className="calendar icon"></i>
          </div>
        }
        style={{ minWidth: 250 }}
        open={open}
        onClose={() => setOpen(false)}
        on="click"
      >
        <Segment>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: 10 }}>
            <span style={{ flex: 1 }} onClick={decreaseYear}>
              <button className="ui basic compact icon button">
                <i className="angle left icon"></i>
              </button>
            </span>
            <span style={{ flex: 3, textAlign: "center" }}>{selectedYear}</span>
            <span style={{ flex: 1 }} onClick={incrementYear}>
              <button className="ui basic compact icon button">
                <i className="angle right icon"></i>
              </button>
            </span>
          </div>
          <div
            style={{
              display: "grid",
              gap: 1,
              gridTemplateColumns: "1fr 1fr 1fr",
              backgroundColor: "rgba(0,0,0,.1)",
              border: "1px solid rgba(0,0,0,.1)",
              borderRadius: "0.28571429rem",
            }}
          >
            {months.map((month, monthIndex) => (
              <button
                className="clndr-cell"
                style={{
                  backgroundColor: monthIndex === selectedMonth ? "#333" : "",
                  color: monthIndex === selectedMonth ? "white" : "",
                }}
                onClick={() => {
                  setOpen(false);
                  setSelectedMonth(monthIndex);
                }}
                key={monthIndex}
              >
                {month}
              </button>
            ))}
          </div>
        </Segment>
      </Popup>
    </div>
  );
};

MonthYearPicker.propTypes = {
  locale: PropTypes.string,
  onChange: PropTypes.func,
};
